<template>
    <div class="data-grid-toolbar-item" @click="onClick">
        <el-tooltip class="item" effect="dark" :content="name" placement="top">
            <img :src="icon"/>
        </el-tooltip>
    </div>
</template>

<script>
export default {
    props: {
        icon: {},
        name: {}
    },
    methods: {
        onClick () {
            this.$emit('click')
        }
    }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>


// WEBPACK FOOTER //
// src/components/framework/data-grid/toolbar/item.vue